import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class supplierIntegrationService {

  constructor(private config: ConfigService, private http: HttpClient) { }

  getTokenSIIGO = (token: string, data: any) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/IntegrationSupplier/TokenSIIGO"
    return this.http.post(url, data, requestOptions);
  }


  getClientSiigo = (token: string, tokenSIIGO: string, identification: string) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/IntegrationSupplier/GetClientSIIGO/" + identification;
    return this.http.post(url, tokenSIIGO, requestOptions);
  }


  getClientsSiigo = (token: string, tokenSIIGO: string, page: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/IntegrationSupplier/GetClientsSIIGO/" + page;
    return this.http.post(url, tokenSIIGO, requestOptions);
  }

  // obtener SKU para actualizar información en referencia de inventario y lista de precios
  getProductSiigoSKU = (token: string, tokenSIIGO: string, code: string) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/IntegrationSupplier/GetProductSIIGO/" + code;
    return this.http.post(url, tokenSIIGO, requestOptions);
  }


  getProductsSiigo = (token: string, tokenSIIGO: string, page: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/IntegrationSupplier/GetProductsSIIGO/" + page;
    return this.http.post(url, tokenSIIGO, requestOptions);
  }

  getSaleSiigo = (token: string, identificacion: string) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/IntegrationSupplier/getSalesSIIGO/" + identificacion;
    return this.http.get(url, requestOptions);
  }

  // obtener estado de la venta
  getSaleSiigoNoAut = (identificacion: string, idProveedor: number) => {
    const url = this.config.urlService + "api/IntegrationSupplier/getSalesSIIGONoAut/" + identificacion + "/" + idProveedor;
    return this.http.get(url);
  }

  setSaleSiigo = (token: string, json: any, idTicket: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/IntegrationSupplier/setSaleSIIGO/" + idTicket;
    return this.http.post(url, json, requestOptions);
  }


  getDirectSIIGOSKU = (tokenSIIGO: string, code: string) => {
    const url = "https://api.siigo.com/v1/products?" + code;
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${tokenSIIGO}`),
      "Partner-Id": "PROPIO"
    });
    return this.http.get(url, requestOptions);
  }


    /// información de productos desde SIIGO to BD
    setSKUFromSIIGO(token: string, data: object) {
      const requestOptions: object = {
        headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
        'responseType': 'text'
      }
      const url = this.config.urlService + "api/Producto/SetIntegrationSystemImport";
      return this.http.put(url, data, requestOptions);
    }
}
